// sessionStorage and localStorage are considered 3rd party by Chromium when embedded
// this method checks if storage is available
export default () => {
  try {
    return Boolean(sessionStorage && localStorage);
  } catch (e) {
    return false;
  }
};
